import axios from 'axios';
import { UserModel } from './_models';
import request from '../../../../utils/request';
import moment from 'moment';

const API_URL = process.env.REACT_APP_API_URL;
const CAPTCHA_FULL = process.env.REACT_APP_CAPTCHA_FULL;

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`;
export const LOGIN_URL = `${API_URL}/api/users/Login`;
export const REGISTER_URL = `${API_URL}/Users/Register`;
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`;

export function login(
	email: string,
	password: string,
	captchaText: string,
	captchaInput: string,
	captchaToken: string
) {
	const params = new FormData();
	params.append('email', email);
	params.append('password', password);
	params.append('DNTCaptchaText', captchaText);
	params.append('DNTCaptchaInputText', captchaInput);
	params.append('DNTCaptchaToken', captchaToken);
	// params.append('DNTCaptchaId', 'dntCaptcha8a6acd2bd2284ca3917b43b6f4e2c0c242');

	if(CAPTCHA_FULL == '1') {
		return request.post('/Users/LoginWithCaptcha', params, {
			'Content-Type': 'multipart/form-data',
		});
	} else {
		return request.post('/users/login', {
			email,
			password,
		});
	}
}

export function register(
	email: string,
	name: string,
	password: string,
	password_confirmation: string,
	role_number?: number,
	capel_id?: string,
	cust_number?: string
) {
	return request.post('/Users/Register', {
		email,
		name,
		password,
		password_confirmation,
		created_on: moment().format('YYYY-MM-DD'),
		role_number: role_number,
		capel_id: capel_id,
		cust_number: cust_number
	});
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
	return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
		email,
	});
}

export function getUserByToken(token: string) {
	return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
		api_token: token,
	});
}
